<template>
    <v-card class="mb-2">
        <v-card-text class="grey lighten-3 elevation-2">
            <!-- TODO : (onSubmit="return false") Bug avec vuetify sur v-form avec un seul v-text-field : https://github.com/vuetifyjs/vuetify/issues/4302 -->
            <v-form
                v-model="isFormValid"
                on-submit="return false;"
                @submit="checkForZipcode">
                <v-layout
                    align-center
                    :class="{'wrap': $vuetify.breakpoint.smAndDown}"
                >
                    <v-flex
                        xs12
                        md4
                        offset-md2
                        :class="{'title text-right' : $vuetify.breakpoint.mdAndUp}">
                        <span class="mr-6 font-weight-bold">
                            {{ '* ' + $t(`appt.enterZipCode`) }}
                        </span>
                    </v-flex>
                    <v-flex xs11 md4>
                        <v-text-field
                            v-model="localZipcode"
                            :disabled="disabled"
                            :label="$t('base.zipCode')"
                            :aria-label="getAriaLabel"
                            tabindex="0"
                            :rules="[requiredField(), getFormRule('zipCodeCa')]"
                            v-mask="$t('base.postalCodeMask')"
                            ref="zipcodeField"
                            @keydown.enter.prevent="checkForZipcode"
                            @input="onInputZipcode"
                            @change="onInputZipcode"
                        >
                            <template v-slot:append-outer>
                                <v-btn
                                    icon
                                    class="mt-0"
                                    :aria-label="$t('accessibility.postalCodeBtn')"
                                    tabindex="0"
                                    :disabled="isZipcodeInvalid"
                                    data-testid="postalCodeBtn"
                                    @click="checkForZipcode"
                                    @keydown.enter.prevent="checkForZipcode"
                                >
                                    <v-icon>fa-search</v-icon>
                                </v-btn>
                            </template>
                        </v-text-field>
                    </v-flex>
                </v-layout>
            </v-form>
        </v-card-text>
    </v-card>
</template>

<script>
import { mapGetters } from 'vuex';
import { toUpper } from 'lodash';
import { formRules } from '@/mixins/form-rules';

export default {
    name: 'step-zip-code-filter',
    props: {
        zipcode: { required: true },
        disabled: { required: false, type: Boolean, default: false },
    },
    computed: {
        ...mapGetters({
            locale: 'locale',
        }),
        localZipcode: {
            get: function() {
                return this.$store.getters['places/getPostalCode'];
            },
            set(val) {
                if(this.zipcode !== val) {
                    this.$store.commit('places/SET_POSTAL_CODE', toUpper(val));
                }
            },
        },
        getAriaLabel() {
            return this.localZipcode ? this.$i18n.t('accessibility.postalCodeValue', [this.localZipcode]) : this.$i18n.t('accessibility.postalCode');
        },
        isZipcodeInvalid() {
            return !this.isFormValid || this.disabled;
        }
    },
    data: () => ({
        // Loading
        loading: false,

        // Form
        isFormValid: false,
    }),
    mounted() {
        if (this.zipcode) {
            this.checkForZipcode();
        }
    },
    mixins: [formRules],
    methods: {
        /**
         * Emits postal code to parent and show places
         */
        checkForZipcode() {
            if(!this.loading && this.isFormValid) {
                this.$store.commit('places/SET_POSTAL_CODE_IS_VALID', true);
                this.$emit('checkForZipcode');
            }
        },
        /**
         * Emits hides places to parent
         */
        hidePlaces() {
            this.$store.commit('places/SET_POSTAL_CODE_IS_VALID', false);
            this.$emit('hidePlaces');
        },
        async onInputZipcode() {
            this.hidePlaces();
            await this.$nextTick();
            await this.$refs.form?.validate();
        }
    },
};
</script>
